export const DAYS_TO_SHOW_ATTESTATION = 7;
export const START_OF_DAY_TIME_UTC = '06:00:00.000Z';
